import {
  UPDATE_LOCALS,
  UPDATE_RECOMMENDATIONS,
  GET_LOCALS,
} from './../../mutation-types';

export default {
  [UPDATE_LOCALS](state, locals) {
    state.patrocinados = locals.patrocinados;
    state.tipoComida = locals.tipo_comida;
    state.distritos = locals.distritos;
    state.colecciones = locals.colecciones;
    state.currentCountry = locals.pais_actual;
    state.locals = locals.locales;
    state.houndreds = locals.locales.filter(el => el.MilPuntos !== '0' || el.QuinientosPuntos !== '0');
  },
  [UPDATE_RECOMMENDATIONS](state, cats) {
    state.recommendations = cats;
  },
  [GET_LOCALS](state) {
    return state.locals;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/locals/mutations.js